//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { has } from 'lodash';
//  -- Actions ------------------------
import * as Sentry from '@sentry/react';
import { sortBy } from 'lodash';
import * as PhrasesActions from './actions';
import { validateObjectData } from 'utils/methods/math';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create vocabulary --------------------
const onFilterPhrasesStd = (bookVocabulary, bookId, pageId, currentUser) => {
  let sorted_obj = sortBy(bookVocabulary, [
    function (o) {
      if (o.data && typeof o.data.phrase === 'string') {
        return o.data.phrase.toLowerCase();
      }
      return '';
    },
  ]);
  return sorted_obj;
};
export const handleCreatePhrases = (data) => async (dispatch) => {
  await dispatch(PhrasesActions.createPhrases());
  try {
    const phrasesData = await apis.post('vocabularyRDS', `/addPhrases`, {
      body: data,
    });
    if (data.id) {
      await dispatch(PhrasesActions.updatePhrasesSuccess(phrasesData));
    } else {
      await dispatch(PhrasesActions.createPhrasesSuccess(phrasesData));
    }
    return phrasesData;
  } catch (error) {
    if (error && error.message != 'Network Error') {
      Sentry.captureException(`1134 Error creating phrases: ${error}`);
    }
  }
};

//  -- List vocabulary ----------------
export const handleListPhrasesNew = (data, bookId, pageId, currentUser) => async (dispatch) => {
  try {
    const phrasesRDS = await apis.post('vocabularyRDS', `/listPhrases`, {
      body: data,
    });
    let phrasesupdatasort = onFilterPhrasesStd(phrasesRDS, bookId, pageId, currentUser);
    await dispatch(PhrasesActions.listPhrasesSuccess(phrasesupdatasort));

    return phrasesRDS;
  } catch (error) {
    if (error && error.message != 'Network Error') {
      Sentry.captureException(`1136 Error listing phrases: ${error}`);
    }
  }
};

export const handleListPhrasesStud = (data, bookId, pageId, currentUser) => async (dispatch) => {
  try {
    const phrasesRDS = await apis.post('vocabularyRDS', `/listPhrases`, {
      body: data,
    });
    return phrasesRDS;
  } catch (error) {
    if (error && error.message != 'Network Error') {
      Sentry.captureException(`1137 Error listing phrases student: ${error}`);
    }
  }
};

export const handleGetStudentPhraseCount = (data) => async (dispatch) => {
  try {
    const studentPhraseCounts = await apis.post('vocabularyRDS', `/getStudentWordCount`, {
      body: { ...data, type: 'phrases' },
    });

    if (Array.isArray(studentPhraseCounts)) {
      return studentPhraseCounts;
    }
  } catch (error) {
    if (error && error.message != 'Network Error') {
      Sentry.captureException(`Error getting student phrase count: ${error}`);
    }
  }
};

export const setDataPhrases = (data) => async (dispatch) => {
  await dispatch(PhrasesActions.listPhrasesSuccess(data));
};

export const handleGeneratePhrasesWithAI = (data) => async (dispatch) => {
  try {
    const phrasesData = await apis.post('vocabularyRDS', `/generate_phrases`, {
      body: data,
    });
    if (phrasesData && phrasesData.id) {
      await dispatch(PhrasesActions.createPhrasesSuccess({valid:true,...phrasesData}));
    }
    return {valid:true,...phrasesData};
  } catch (error) {
    if (error) {
      Sentry.captureException(`1140 Error generating phrases with ai: ${error}`);
      return null;
    }
  }
};

export const handleGeneratePhrasesWithMode = (data) => async (dispatch) => {
  try {
    const phrasesData = await apis.post('vocabularyRDS', `/generate_phrases_with_mode`, {
      body: data,
    });
    if (phrasesData && phrasesData.id) {
      await dispatch(PhrasesActions.createPhrasesSuccess({valid:true,...phrasesData}));
    }
    return {valid:true,...phrasesData};
  } catch (error) {
    if (error) {
      Sentry.captureException(`1141 Error generating vocabulary with mode: ${error}`);
      return null;
    }
  }
};

//  -- List vocabulary ----------------
export const handleListPhrases = (bookId, pageId, currentUser) => async (dispatch) => {
  try {
    const phrasesRDS = await apis.post('vocabularyRDS', `/listPhrases`, {
      body: { book_id: bookId, page: pageId, chapter: bookId, created_by: currentUser?.role || 'teacher', user_id: currentUser?.id || '', class_id: currentUser?.class_id || '' }
    });
    let phrasesupdatasort = onFilterPhrasesStd(phrasesRDS, bookId, pageId, currentUser);

    await dispatch(PhrasesActions.listPhrasesSuccess(phrasesupdatasort));
    return phrasesRDS;
  } catch (error) {
    if (error && error.message != 'Network Error') {
      Sentry.captureException(`1142 Error listing phrases: ${error}`);
    }
  }
};

//  -- Delete Book vocabulary ----------
export const handleDeletePhrases = (id) => async (dispatch) => {
  if (!id) return;
  dispatch(PhrasesActions.deletePhrases());
  try {
    const phrases = await apis.del('vocabularyRDS', `/deletePhrases/${id}`);
    if (has(phrases, 'id')) {
      await dispatch(PhrasesActions.deletePhrasesSuccess(phrases));
    }
  } catch (error) {
    if (error && error.message != 'Network Error') {
      Sentry.captureException(`1143 Error deleting phrases: ${error}`);
    }
  }
};
